import React from 'react';
import { FormulaComponentProps } from '../../types/index';
import { MathMLRenderer, createMathML } from '../shared/MathMLRenderer';

export const JaccardVda: React.FC<FormulaComponentProps> = ({ className, style }) => {
  const mathML = createMathML(`
    <mrow>
      <msub>
        <mi mathvariant="italic">Jaccard</mi>
        <mrow>
          <mspace width="0.167em" />
          <mi>V</mi>
        </mrow>
      </msub>
      <mo>=</mo>
      <mfrac>
        <mrow>
          <msub>
            <mi>V</mi>
            <mn>1</mn>
          </msub>
          <mo>∩</mo>
          <msub>
            <mi>V</mi>
            <mn>2</mn>
          </msub>
        </mrow>
        <mrow>
          <mi>V</mi>
          <mn>1</mn>
          <mo>∪</mo>
          <mi>V</mi>
          <mn>2</mn>
        </mrow>
      </mfrac>
    </mrow>
  `);

  return <MathMLRenderer mathML={mathML} className={className} style={style} />;
};